import Header from '../../components/Header/Header';
import WhatsappFloatingButton from '../../components/WhatsappFloatingButton/WhatsappFloatingButton';
import Footer from '../../components/Footer/Footer';
import {
  ProductGrid,
  ProductsPageWrapper,
  Title,
} from './Products.styled';
import React, { useState, useEffect } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { PRODUCT_CATEGORIES, PRODUCTS } from '../../utils/constants';
import kebabToTitleCase from '../../utils/kebabToTitleCase';
import ProductCard from '../../components/ProductCard/ProductCard';
import { useNavigate, useLocation } from 'react-router-dom';

const Products = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedCategory, setSelectedCategory] = useState(PRODUCT_CATEGORIES[0]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const category = params.get('category');

    if (category === 'all-products') {
      setSelectedCategory('all-products');
    }
    // Optionally set a default if category param is missing
    else if (!category) {
      params.set('category', 'all-products');
      navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    } else {
      setSelectedCategory(category);
    }
  }, [location.search, navigate, location.pathname]);

  const onSelectTab = (category) => {
    const params = new URLSearchParams(location.search);
    params.set('category', category);
    setSelectedCategory(category);
    navigate(`${location.pathname}?${params.toString()}`);
  }

  const onProductClick = (product) => {
    navigate(`/products/${product.id}`);
  }

  const renderAllProducts = () => {
    return PRODUCTS.map((product, i) => {
      return (
        <ProductCard product={product} key={i} onClick={() => onProductClick(product)} />
      );
    });
  }

  const renderSelectedProducts = () => {
    return PRODUCTS.filter(product => product.category === selectedCategory).map((product, i) => {
      return (
        <ProductCard product={product} key={i} onClick={() => onProductClick(product)} />
      );
    });
  }

  return (
    <>
      <Header />
      <ProductsPageWrapper>
        <Title>{kebabToTitleCase(selectedCategory)}</Title>
        <Tabs
          activeKey={selectedCategory}
          onSelect={onSelectTab}
          className="mb-3"
        >
          {PRODUCT_CATEGORIES.map((category) => {
            return (
              <Tab
                eventKey={category}
                title={kebabToTitleCase(category)}
                key={category}
              >
                <ProductGrid>
                  {selectedCategory === 'all-products' ? renderAllProducts() : renderSelectedProducts()}
                </ProductGrid>
              </Tab>
            )
          })}
        </Tabs>
      </ProductsPageWrapper>
      
      <Footer />
      <WhatsappFloatingButton />
    </>
  );
}

export default Products;
